import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Broom.es.js";
const r = o.forwardRef((m, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...m, weights: a }));
r.displayName = "BroomIcon";
const n = r;
export {
  n as Broom,
  r as BroomIcon
};
